import Home from '../pages/home/Home'

import { USER_ROLES } from '../utils/userRole'

const permissions = [USER_ROLES.ADMIN]

const HomeRoutes = [
  {
    // index: true,
    path: '/overview',
    component: Home,
    exact: true,
    permissions,
  },
]

export default HomeRoutes
